import React from 'react';
import styles from './TariffsTableBlock.module.scss';
import { ImportantIcon } from '../Icons/ImportantIcon';
import Popup from 'reactjs-popup';

interface Props {
    isTariffsPage?: boolean;
    isVip?: boolean;
}

const popupContentStyle = {
    background: 'white',
    borderRadius: 12,
    boxShadow: '0px 10px 30px rgba(63, 169, 245, 0.1)',
    width: '100%',
    maxWidth: 360,
    padding: '1rem',
};

const TariffsTableBlock: React.FC<Props> = ({
    children,
    isTariffsPage,
    isVip,
}) => (
    <div className={styles.container}>
        <p>Оплата производится победителем закупки*</p>

        <div className={styles.tableContainer}>
            <table>
                <thead>
                    <tr>
                        <th>
                            {isTariffsPage ? 'Условия закупки' : '№\u00A0лота'}
                        </th>
                        <th>
                            {!isVip && (
                                <div>
                                    С лицензией “Оптимальные условия”
                                    <Popup
                                        trigger={
                                            <div>
                                                <ImportantIcon />
                                            </div>
                                        }
                                        on="hover"
                                        position="bottom center"
                                        contentStyle={popupContentStyle}
                                    >
                                        Дает возможность подачи заявки на
                                        льготных условиях (1 % от НМЦ, не менее
                                        7 500 руб. и не более 175 000 руб.)
                                    </Popup>
                                </div>
                            )}
                            {isVip && 'Оплата победителем *'}
                        </th>
                        {!isVip && <th>Без лицензии</th>}
                    </tr>
                </thead>
                <tbody>{children}</tbody>
            </table>
        </div>
    </div>
);

export default TariffsTableBlock;
